import type { CiselnikyCiselnikPolozkaDtoEmbassyOffice } from '@gov-nx/api';
import {
	embassyOfficeListQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import { hasProperty } from '@gov-nx/core/types';
import { AlphabeticalComparator } from '@gov-nx/utils/common';
import { useAppLanguage } from '../Localization/useAppLanguage';

export const useEmbassyOfficeQuery = () => {
	const { language } = useAppLanguage();
	const { axiosInstance } = useAxiosInstance();

	const getValue = (office: CiselnikyCiselnikPolozkaDtoEmbassyOffice) =>
		language === 'cs' ? office.nazevCs : office.nazevEn;

	const query = usePoQuery({
		queryKey: ['embassy-offices'],
		queryFn: async () => embassyOfficeListQuery(axiosInstance),
	});

	const embassyOffices = (query.data?.seznam ?? []).filter(hasProperty('kod'));

	const embassyOfficesOptions = embassyOffices
		.map((embassy) => ({
			value: embassy.kod,
			label: getValue(embassy) ?? '',
		}))
		.sort(AlphabeticalComparator);

	return {
		getValue,
		embassyOffices,
		embassyOfficesOptions,
		data: query.data,
		error: query.error,
		isLoading: query.isLoading,
	};
};
